import {
  backButton,
  bindThemeParamsCssVars,
  bindViewportCssVars,
  init as initSDK,
  initData,
  isTMA,
  miniApp,
  mountBackButton,
  mountMainButton,
  mountMiniApp,
  mountSecondaryButton,
  mountSwipeBehavior,
  mountViewport,
  requestFullscreen,
  secondaryButton,
  setDebug,
  swipeBehavior,
} from '@telegram-apps/sdk-react';

/**
 * Initializes the application and configures its dependencies.
 */
export async function initTelegram() {
  // Set @telegram-apps/sdk-react debug mode.
  setDebug(import.meta.env.MODE === 'development');

  // Initialize special event handlers for Telegram Desktop, Android, iOS, etc.
  // Also, configure the package.
  const isTelegram = isTMA();

  if (!isTelegram) {
    throw new Error('ERR_ENVIRONMENT');
  }

  initSDK();

  // Check if all required components are supported.
  if (!backButton.isSupported() || !miniApp.isSupported()) {
    throw new Error('ERR_NOT_SUPPORTED');
  }

  const mountedElementsSupports = [
    miniApp.isSupported(),
    backButton.isSupported(),
    secondaryButton.isSupported(),
    swipeBehavior.isSupported(),
    requestFullscreen.isSupported(),
  ];

  if (!mountedElementsSupports.every(Boolean)) {
    throw new Error('ERR_NOT_SUPPORTED');
  }

  mountBackButton.ifAvailable();
  mountMainButton.ifAvailable();
  mountSecondaryButton.ifAvailable();
  mountSwipeBehavior.ifAvailable();

  initData.restore();

  await Promise.all([
    mountMiniApp.isAvailable() &&
      mountMiniApp().then(() => {
        bindThemeParamsCssVars();
      }),
    mountViewport.isAvailable() &&
      mountViewport().then(() => {
        bindViewportCssVars();
      }),
  ]);
}
